
<template>
<div id="app">
  <chc-header></chc-header>
  <navbar></navbar>
  <router-view/>
</div>
</template>

<script>
import auth from '@/auth'
import router from '@/router'
import Navbar from '@/components/Navbar'
import ChcHeader from '@/components/ChcHeader'

export default {
  name: 'HomePage',
  data () {
    return {
      user: auth.user
    }
  },
  mounted () {
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.checkRoute(to, from)
    })
  },
  beforeRouteUpdate (to, from, next) {
    next(vm => {
      vm.checkRoute(to, from)
    })
  },
  methods: {
    checkRoute (to, from) {
      auth.checkAuth(() => {
      }, () => {
        router.replace({name: 'Login'})
      })
    }
  },
  props: {
    noLogin: {
      default: false
    }
  },
  components: {
    ChcHeader,
    Navbar
  }
}
</script>

<style>

#app {
    min-height: 1000px;
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue